import React, { useEffect } from "react";
import "./swadaaEmpowerment.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { director_image } from "../../assets";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import GetStartedSection from "../../components/getStartedSection/GetStartedSection";
import SEO from "../../components/SEO/SEO";

const SwadaaEmpowerment = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const navigate = useNavigate();
  return (
    <div>
      <SEO
        title="Empowerment Programs"
        description="Swadaa Empowerment Programs support women, youth, and widows with skills training, entrepreneurship development, mentorship, and financial assistance to build sustainable livelihoods and stronger communities."
        keywords="women empowerment, youth empowerment, widows support, entrepreneurship training, skills development, mentorship, sustainable livelihoods"
      />
      <Navbar />
      <div className="homeAbout_sectionOneCont">
        <div className="homeAbout_sectionOne_gen">
          <div className="homeAbout_startedHeader">Swadaa Enlightenment </div>
          <div className="homeAbout_startedSub">& Empowerment Initiative</div>

          <div className="homeAbout_paraGen">
            <div>
              <div className="homeAbout_director_image">
                <div className="homeAbout_director_image____">
                  <img src={director_image} />
                </div>
              </div>
              <div className="homeAbout_director_name">
                Com. Chijioke Ugochukwu
              </div>
              <div className="homeAbout_director_title">Director General</div>
            </div>

            <div className="homeAbout_para">
              Our Empowerment Programs are designed to uplift and support
              individuals from various backgrounds, including women, youth, and
              widows. We offer a comprehensive range of services aimed at
              providing them with the tools and resources they need to thrive.
              <div style={{ marginTop: "10px" }}>
                Through skills development workshops, participants can enhance
                their abilities and acquire new skills that are essential for
                personal and professional growth. Our entrepreneurship training
                equips aspiring entrepreneurs with the knowledge and expertise
                needed to start and run successful businesses.
              </div>
              <div style={{ marginTop: "10px" }}>
                In addition to practical training, we also offer mentorship
                programs where individuals can receive guidance and support from
                experienced professionals in their respective fields. This
                mentorship helps them navigate challenges, set goals, and make
                informed decisions.
              </div>
              <div style={{ marginTop: "10px" }}>
                Financial assistance is another crucial aspect of our
                Empowerment Programs. We provide support to those in need,
                whether it's through scholarships, grants, or microloans, to
                help them overcome financial barriers and pursue their
                ambitions.
              </div>
              <div style={{ marginTop: "10px" }}>
                Overall, our goal is to empower marginalized groups and promote
                inclusivity, equality, and self-sufficiency in society. By
                offering these programs, we believe we can create positive
                change and foster a more prosperous and equitable community for
                all.
              </div>
            </div>
          </div>

          {/* <a
          href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
          target="_blank"
          className="getStarted_btn"
          style={{ textDecoration: "none" }}
        >
          Lets Get Started
        </a> */}

          <div
            // href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
            // target="_blank"
            className="getStarted_btn"
            style={{ textDecoration: "none" }}
            onClick={() => {
              navigate("/contact");
            }}
          >
            Lets Get Started
          </div>
        </div>
      </div>
      <GetStartedSection />
      <Footer />
    </div>
  );
};

export default SwadaaEmpowerment;
